import { type WalletLimits } from '@capsicum/common';

// Type for Sell error messages, used on useWalletsBalance hooks.
// to avoid sending empty messages with buy limits
export type SellLimits = Exclude<
	WalletLimits,
	| WalletLimits.DebitRestriction
	| WalletLimits.FanTokenOfferingMaximal
	| WalletLimits.FanTokenOfferingMaximalWithWalletBalance
	| WalletLimits.FanTokenOfferingMinimal
	| WalletLimits.HoldingRestriction
	| WalletLimits.Minimal
	| WalletLimits.PspMaxAmount
	| WalletLimits.RegulatoryRestriction
>;

export const DEFAULT_MIN_SELLABLE_QUANTITY = 1;

export type ErrorContent = { message: string; tooltip?: string; validationType?: WalletLimits };
export type ErrorMessage = Record<SellLimits, ErrorContent>;
